import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate';

Vue.use(Vuex)
/* eslint-disable */
export default new Vuex.Store({
    state: {
        user: {
            loggedIn: false,
            poll: false
        },
        customer: {
            name: '',
            postalCode: '',
            city: '',
            address: '',
            phone: '',
            email: ''
        },
        isSidebarActive: false,
        themeColor: "#2962ff",
    },
    mutations: {
        IS_SIDEBAR_ACTIVE(state, value) {
            state.isSidebarActive = value;
        },
        loginUser(state) {
            state.user.loggedIn = true;
            state.user.poll = true;
        },
        logoutUser(state) {
            state.user.poll = false;
            state.user.loggedIn = false;
        },
        saveCustomerData(state, payload) {
            state.customer.name = payload.customerName;
            state.customer.postalCode = payload.customerPostalCode;
            state.customer.city = payload.customerCity;
            state.customer.address = payload.customerAddress;
            state.customer.phone = payload.customerPhone;
            state.customer.email = payload.customerEmail;
        }
    },
    actions: {},
    getters: {
        loggedIn: state => state.user.loggedIn,
    },
    plugins: [createPersistedState()]
})
